import { type FunctionComponent, } from "react"

import "./ValueTile.scss";



export declare type ValueTileProps = {
	label: string;
	value: number | string;
	format?: "number" | "money" | "none" | "points";
};


export const ValueTile: FunctionComponent<ValueTileProps> = ({
	label,
	value,
	format = "none",
}) => {

	const classes = () => [ `value-tile` ].join(" ");
	const valueString = () => {
		switch( format ) {
			case "number": return value.toLocaleString();
			case "money": new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(Number(value));
			case "points": return Intl.NumberFormat("en-us").format(Math.round(Number(value)));
			default:
				return value.toString();
		}
	}
	return (
		<div className={classes()}>
			<div className="label"><p className="text-xl">{label}</p></div>
			<div className="value"><h3>{valueString()}</h3></div>
		</div>
	);

}
